import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import CONFIG from '../../config';
import NavBarEstudianteTutor from './NavBarEstudianteTutor';

const URL_CALIFICACIONES = `${CONFIG.API_URL}/operarCalificaciones.php`;

function Calificaciones({ acceder, configuracion }) {
    const [userId, setUserId] = useState(parseInt(localStorage.getItem('loggedUserId'), 10) || null);
    const loggeduserCurso = localStorage.getItem('loggeduserCurso');
    const navigate = useNavigate();
    const [cursoParticipa, setCursoParticipa] = useState([]);
    const [valoraciones, setValoraciones] = useState([]);
    const [instanciasCohorte, setInstanciasCohorte] = useState([]);
    const anioActual = new Date().getFullYear();
    const [datoEstudiante, setDatoEstudiante] = useState([]);
    const llamoTutor = localStorage.getItem('kte') || null; //llave de acceso a los datos  del estudiante tutelado

    useEffect(() => {
        if (!acceder) {
            localStorage.clear();
            navigate('/');
            return;
        }

        if (llamoTutor && llamoTutor !== "null") {
            const [fecha, estudianteStr, idTutor] = llamoTutor.split("&");
            const estudiante = JSON.parse(estudianteStr);
            setDatoEstudiante(estudiante);
            setUserId(estudiante.estudiante_id);  // recién acá se define el userId real
        } else {
            // si no hay tutor, usamos el userId del localStorage
            setUserId(localStorage.getItem('loggedUserId'));
        }
    }, [acceder, llamoTutor]);

    // efecto separado para cargar datos SOLO cuando userId esté seteado
    useEffect(() => {
        if (!userId) return;   // evita disparar cuando está vacío
        obtenerDatos();
    }, [userId]);

    const data = {
        id_usuario: userId,
        ciclo: anioActual,
        modo: 'buscarCursosyCalificaciones'
    };

    const obtenerDatos = () => {
        console.log('data', data);
        axios.post(URL_CALIFICACIONES, data)
            .then(res => {
                console.log('ddd', res.data);
                if (!res.data.error) {
                    setValoraciones(res.data.valoraciones);
                    setCursoParticipa(res.data.cursos);
                    setInstanciasCohorte(res.data.instancias);
                } else {
                    setValoraciones([]);
                    setCursoParticipa([]);
                    setInstanciasCohorte([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };
    // progreso general solo leo orden M modulos
    const modulos = cursoParticipa.filter(
        c => c.orden?.toUpperCase() === "M"
    );

    const totalModulos = modulos.length;

    const modulosAprobados = modulos.filter(
        c => Number(c.aprobado) === 1
    ).length;

    const porcentajeLogrado =
        totalModulos > 0
            ? Math.round((modulosAprobados * 100) / totalModulos)
            : 0;

    const porcentajePendiente = 100 - porcentajeLogrado;

    return (
        <div className='container-principal'>
            {llamoTutor && <NavBarEstudianteTutor estudiante={datoEstudiante} configuracion={configuracion} />}
            <div className='card shadow border-1 p-4'>
                <h4>Calificaciones por cursos</h4>
                <div className="mb-2">
                    <div className="mb-2">
                        <div
                            className="progress"
                            style={{
                                height: "12px",
                                borderRadius: "10px"
                            }}
                        >
                            <div
                                className="progress-bar bg-success"
                                style={{
                                    width: `${porcentajeLogrado}%`
                                }}
                            >
                            </div>

                            <div
                                className="progress-bar bg-light text-dark"
                                style={{
                                    width: `${porcentajePendiente}%`
                                }}
                            >
                            </div>
                        </div>

                        <div className="small text-muted mt-1">
                            <i className="fa-solid fa-circle-check text-success me-1"></i>
                            {modulosAprobados} logrados
                            {" • "}
                            {totalModulos - modulosAprobados} pendientes
                            {" • "}
                            {porcentajeLogrado}% de avance
                        </div>
                    </div>
                </div>


                <hr />
                <div class="table-responsive">
                    <table className='table table-sm '>
                        <thead>
                            <tr>
                                <th>Módulo</th>
                                {instanciasCohorte.length != 0 && instanciasCohorte.map((i, index) => (
                                    <th key={index}>{i.nombre_instancia}{i.id_instancia}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {cursoParticipa.length != 0 && cursoParticipa.map((c, i) => (
                                <tr key={i}>
                                    <td>{c.nombre_espacio && c.nombre_espacio.toLowerCase().includes('años')
                                        ? 'Sala'
                                        : c.nombre_espacio?.toLowerCase() || ''}</td>
                                    {instanciasCohorte.length != 0 && instanciasCohorte.map((inst, index) => {
                                        const calificacion = (valoraciones || []).find(
                                            (v) =>
                                                v.id_instancia === inst.id && v.id_usuario == userId && v.id_curso === c.id
                                        );
                                        return (
                                            <td key={index}>
                                                {calificacion && calificacion.estado_aprobacion === 'publicada' && (calificacion.valor > 0 || calificacion.valor !== '') ? <strong className='btn btn-sm btn-outline-secondary'>{calificacion.valor}</strong> : '-'}
                                                {calificacion && calificacion.estado_aprobacion === 'publicada' && calificacion.observacion !== '' &&
                                                    <button
                                                        type='button'
                                                        className='btn btn-sm btn-outline-secondary ms-1'
                                                        onClick={() => alert(calificacion.observacion)}
                                                    >
                                                        <i className="fa-regular fa-file-lines"></i>
                                                    </button>
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Calificaciones;
